import { Suspense } from 'react';

import { AppRouter } from './providers/router';
import './styles/index.scss';

const App = () => {
  return (
    <Suspense>
      <AppRouter />
    </Suspense>
  );
};

export default App;
